
import { Component, OnInit } from "@angular/core";

@Component({
    //selector: "customer-dashboard",
    templateUrl: "../templates/template1/views/impersonation.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/dashboard.less"
    ]
})
export class ImpersonationComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {};
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/impersonation.component.ts